import AgentChatLoginEvent from './AgentChatLoginEvent';
import AgentChatLogoffEvent from './AgentChatLogoffEvent';

export default {
  AgentChatLoginEvent,
  AgentChatLogoffEvent,
};
